import { GestureItem } from "@amzn/client-workbench-api-model";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { useIntl } from "react-intl";

import { StepBodyStyledText } from "@/components/Commons/StepBodyStyledText";
import Video from "@/components/Commons/Video";
import { VideoFileConfig } from "@/types/common";

interface ChallengeActionsProps {
  // gesture items that we retrieve from the backend.
  gestureItems: GestureItem[];
}

/**
 * Challenge actions list that will be used to verify NHs identities.
 *
 * @param props A ChallengeActionsProps interface
 */
export default function ChallengeActions({
  gestureItems,
}: ChallengeActionsProps): JSX.Element {
  const intl = useIntl();

  return (
    <Row gridGap="S300">
      {gestureItems.map((gestureItem: GestureItem, index: number) => {
        const videoFileConfig: VideoFileConfig = {
          fileNameOrSrcUrl: { fileSrcUrl: gestureItem.assetUrl },
          fileType: "video/mp4",
        };
        const itemNumber = index + 1;
        const textPrefix =
          index > 0
            ? `${itemNumber}. ${intl.formatMessage({ id: "text-then" })}, `
            : `${itemNumber}.`;
        return (
          <Col key={index} gridGap="S300" width="100%">
            <StepBodyStyledText>
              <Text fontWeight="regular" dataTestId={gestureItem.key}>
                {textPrefix}
                <Text display="inline" fontWeight="regular">
                  {gestureItem.displayText}
                </Text>
              </Text>
            </StepBodyStyledText>
            <Video videoFileConfig={videoFileConfig} />
          </Col>
        );
      })}
    </Row>
  );
}
